import React from 'react'
import Pt from 'prop-types'
import { Panel } from 'react-bootstrap'

import { SignupWithExternalsRecord } from 'internal-components/src/records'
import { Subscribe as SubscribeDimensions } from 'internal-components/src/containers/Dimensions'
import 'rc-steps/assets/index.css'

import { SignupProgressRecord } from '../../../records/SignupProgress'

import Steps from './Steps'

import './ProgressSummary.css'

export default function ProgressSummary({
  signupProgress,
  signupWithExternals,
}) {
  return (
    <Panel className="progress-summary">
      <Panel.Body>
        <SubscribeDimensions>
          {dimensions => (
            <Steps
              dimensions={dimensions}
              signupProgress={signupProgress}
              signupWithExternals={signupWithExternals}
            />
          )}
        </SubscribeDimensions>
      </Panel.Body>
    </Panel>
  )
}

ProgressSummary.propTypes = {
  signupProgress: Pt.instanceOf(SignupProgressRecord).isRequired,
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord).isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Signup/ProgressSummary/index.jsx